import React, { useState } from "react";
import { useTheme } from "../Context/ThemeContext";
import { useLocation } from "react-router-dom";
import { FaSun, FaMoon, FaEllipsisV, FaShareAlt } from "react-icons/fa";
import { RWebShare } from "react-web-share"; // Assuming you want share functionality here too
import styles from "./ThemeToggle.module.css";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isExcludedPage = 
    location.pathname.toLowerCase().includes("share") || 
    location.pathname.toLowerCase().includes("work-video");

  if (isExcludedPage) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {/* --- DESKTOP: Premium Toggle Switch --- */}
      <div className={styles.desktopContainer}>
        <button
          className={styles.themeSwitch}
          onClick={toggleTheme}
          aria-label="Toggle Theme"
        >
          <div className={styles.switchTrack}>
            <div className={styles.iconContainer}>
              <FaMoon size={14} color="#f1c40f" />
            </div>
            <div className={styles.iconContainer}>
              <FaSun size={14} color="#f39c12" />
            </div>
            {/* The Sliding Ball */}
            <div
              className={`${styles.ball} ${
                theme === "dark" ? styles.ballDark : styles.ballLight
              }`}
            ></div>
          </div>
        </button>
      </div>

      {/* --- MOBILE: Three Dots Menu (Top Right) --- */}
      <div className={styles.mobileContainer}>
        {/* Dropdown Menu */}
        <div
          className={`${styles.mobileMenu} ${
            isMenuOpen ? styles.showMenu : ""
          }`}
        >
          {/* Item 1: Theme */}
          <div
            className={styles.menuItem}
            onClick={() => {
              toggleTheme();
              setIsMenuOpen(false);
            }}
          >
            <span className={styles.menuLabel}>
              {theme === "dark" ? "Light Mode" : "Dark Mode"}
            </span>
            {theme === "dark" ? (
              <FaSun color="#FFD700" />
            ) : (
              <FaMoon color="#6b7280" />
            )}
          </div>

          {/* Item 2: Share */}
          <RWebShare
            data={{
              text: "Check out this profile!",
              url: window.location.href,
              title: "Stylelink Profile",
            }}
            onClick={() => setIsMenuOpen(false)}
          >
            <div className={styles.menuItem}>
              <span className={styles.menuLabel}>Share</span>
              <FaShareAlt color="var(--text-color)" />
            </div>
          </RWebShare>
        </div>

        {/* Trigger Button */}
        <button
          className={`${styles.mobileToggleBtn} ${
            isMenuOpen ? styles.active : ""
          }`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <FaEllipsisV />
        </button>

        {/* Backdrop */}
        {isMenuOpen && (
          <div
            className={styles.backdrop}
            onClick={() => setIsMenuOpen(false)}
          ></div>
        )}
      </div>
    </div>
  );
};

export default ThemeToggle;
